/** @jsxImportSource @emotion/react */
import { ReactComponent as Stars } from "@/assets/img/estrellas.svg";
import NovaventaButton from "@/components/formControls/button/NovaventaButton";
import { usePrismic } from "@/hooks/usePrismic";
import { getObject, removeObject } from "@/utils/hooks/localStorage";
import { capitalizaFirstLetter } from "@/utils/utils";
import { Col, Row } from "antd";
import { WelcomeContainer } from "./WelcomeContainer";

export const WelcomeToNovaventa = () => {
  const t = usePrismic();
  const name = capitalizaFirstLetter(getObject("name"));
  const handleClick = () => {
    const passwordUrl = process.env.REACT_APP_ACTIVATE_PASSWORD_URL;
    if (passwordUrl) window.location.assign(passwordUrl);
    removeObject("name");
  };

  return (
    <WelcomeContainer>
      <Row>
        <Col xs={23}>
          <Stars />
        </Col>
        <Col xs={23}>
          <h1>
            {t.constants.BIENVENIDA.replace("${0}", name)}
            <b>{t.constants.ALAFAMNOVA}</b>
          </h1>
          <p>
            {t.constants.YAERES}
            <b>{t.constants.MAMAEMPRE}</b>
            {t.constants.APARTIRPSE}
          </p>
          <p>
            <b>{t.constants.ACTTUCONTRASEÑA}</b>
            {t.constants.INGRESANDOALLINK}
          </p>
        </Col>
        <Col xs={24}>
          <Row justify="center">
            <Col xs={20} sm={13} md={11} lg={9} xl={7}>
              <NovaventaButton
                handleClick={handleClick}
                showArrow={true}
                btnText={t.constants.ACTTUCONTRASEÑA}
              />
            </Col>
          </Row>
        </Col>
        <Col xs={23}>
          <span>{t.constants.TODOSLOSTERMINOS}</span>
        </Col>
      </Row>
    </WelcomeContainer>
  );
};
